module.exports = __webpack_public_path__ + "img/cams-shadow-left.4e4e957.png";